<template>
  <van-image @click="jump" class="top-banner-container" :src="banner.path" v-if="banner && banner.path">
    <template v-if="loading" v-slot:loading>
      <van-loading />
    </template>
  </van-image>
</template>

<script>
import { getBanner } from "@/api";

export default {
  name: "comBanner",
  data() {
    return {
      loading: false,
      banner: {},
    };
  },
  created() {
    this.getBanner();
  },
  methods: {
    async getBanner() {
      this.loading = true;
      const res = await getBanner({ position: 1 });
      this.loading = false;
      if (res.code === 200) {
        this.banner = res.data[0];
      }
    },
    jump() {
      if (this.banner.jumpUrl) {
        //埋点
        this.$collect(2, null, "/bannImg/list", 1, "首页顶部banner");
        window.open(this.banner.jumpUrl, "_blank");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
